export const AQ10 = 
{
    Metadata:{Name:'AQ-10',maxColumn:4,numRows:10},
    Sections:
    [
        {
            Headers:[
                "",
                "Definitely Agree",
                "Slightly Agree",
                "Slightly Disagree",
                "Definitely Disagree"
            ],
            Questions:[
                {
                    Prompt:"1. I often notice small sounds when others do not",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. I usually concentrate more on the whole picture, rather than the small details",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. I find it easy to do more than one thing at once",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. If there is an interruption, I can switch back to what I was doing very quickly",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. I find it easy to 'read between the lines' when someone is talking to me",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. I know how to tell if someone listening to me is getting bored",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. When I'm reading a story I find it difficult to work out the characters' intentions",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. I like to collect information about categories of things (e.g. types of car, types of bird, types of train, types of plant etc)",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. I find it easy to work out what someone is thinking or feeling just by looking at their face",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. I find it difficult to work out people's intentions",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                }
            ]
        }
    ]
}